<template>
  <div id="modalCCDetalhes" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="centroCustoFilho.ccFilho" class="modal-title">
            {{ centroCustoFilho.ccFilho.codCCustoFilho }} -
            {{ centroCustoFilho.ccFilho.nomeCCustoFilho }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <table class="table table-sm table-striped">
          <thead class="bg-teal text-white">
            <tr>
              <th>Mês</th>
              <th class="text-center">Valor Previsto</th>
              <th class="text-end">Valor Reformulado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="mes in centroCustoFilho.meses" :key="mes.mes">
              <td>{{ mes.mes }}</td>
              <td class="text-center">
                {{ moneyToCurrencyBr(mes.valorProposta) }}
              </td>
              <td class="text-end">
                {{ moneyToCurrencyBr(mes.valorReformulacao) }}
              </td>
            </tr>
            <tr v-if="centroCustoFilho.totais" class="fw-bold">
              <td>Total</td>
              <td class="text-center">
                {{ moneyToCurrencyBr(centroCustoFilho.totais.valorProposta) }}
              </td>
              <td class="text-end">
                {{
                  moneyToCurrencyBr(centroCustoFilho.totais.valorReformulado)
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal } from '@/utils/modal'
import { moneyToCurrencyBr } from '@/utils/strings'

export default {
  name: 'CCFilhoDetalhesModal',

  props: {
    codCCustoPai: {
      type: String,
      required: true,
    },
    orcamentoId: {
      type: String,
      required: true,
    },
    codCCustoFilho: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      centroCustoFilho: {},
      moneyToCurrencyBr,
    }
  },

  methods: {
    async getDetalhesCentroCustoFilho() {
      try {
        this.centroCustoFilho = await this.$store.dispatch(
          'getDetalhesCentroCustoFilho',
          {
            codCCustoPai: this.codCCustoPai,
            orcamentoId: this.orcamentoId,
            codCCustoFilho: this.codCCustoFilho,
          },
        )
        showModal('modalCCDetalhes')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },
  },

  mounted() {
    this.getDetalhesCentroCustoFilho()
  },
}
</script>

<style scoped>
th,
td {
  padding-top: 7px;
  padding-bottom: 7px;
}
</style>
